import type { PurchaseOrder } from '../types';

export const initialPurchaseOrders: PurchaseOrder[] = [
  {
    id: 'PO-1',
    supplierId: 1,
    items: [
      {
        lineId: 'line-1',
        inventoryItemId: 1,
        productName: 'Beef Patties',
        quantity: 50,
        costPerUnit: 2.5,
      },
      {
        lineId: 'line-2',
        inventoryItemId: 12,
        productName: 'Salmon Fillets',
        quantity: 20,
        costPerUnit: 8.0,
      },
    ],
    status: 'ordered',
    dateCreated: Date.now() - 86400000 * 5,
  },
  {
    id: 'PO-2',
    supplierId: 2,
    items: [
      {
        lineId: 'line-3',
        inventoryItemId: 4,
        productName: 'Tomatoes',
        quantity: 20,
        costPerUnit: 3.0,
      },
      {
        lineId: 'line-4',
        inventoryItemId: 5,
        productName: 'Lettuce',
        quantity: 20,
        costPerUnit: 1.5,
      },
      {
        lineId: 'line-5',
        inventoryItemId: 6,
        productName: 'Potatoes',
        quantity: 100,
        costPerUnit: 1.2,
      },
    ],
    status: 'received',
    dateCreated: Date.now() - 86400000 * 10,
    dateReceived: Date.now() - 86400000 * 8,
  },
  {
    id: 'PO-3',
    supplierId: 4,
    items: [
      {
        lineId: 'line-6',
        inventoryItemId: 2,
        productName: 'Burger Buns',
        quantity: 100,
        costPerUnit: 0.5,
      },
    ],
    status: 'draft',
    dateCreated: Date.now() - 86400000,
  },
];
